export const cartHasRounding = (features: Record<string, boolean>) =>
  features.RoundDownToQuarter ||
  features.RoundDownToDollar ||
  features.RoundPercentDiscounts ||
  features.RoundToNearestNickel ||
  features.RoundToNearestDollar ||
  features.RoundDownToNearestFiver ||
  features.CurbsideRoundDownToNearestFiver ||
  features.RoundTransactionDownToNearestNickel ||
  features.RoundTransactionUpToNearestNickel ||
  features.RoundTransactionToNearestNickel ||
  features.RoundToNearestQuarter ||
  features.RoundTransactionUpToNearestQuarter;
